import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import {
  PageNotFound404Styled,
  PageNotFoundDescriptionStyled,
  PageNotFoundWrapperStyled,
} from './PageNotFoundStyled';
import { Spacer } from '../Spacer';
import { setIsPageNotFoundActive } from './services';

interface PageNotFoundProps {
  isFullScreen?: boolean;
}

export const PageNotFound = ({ isFullScreen = false }: PageNotFoundProps) => {
  const { t } = useTranslation('pages.notFound');
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setIsPageNotFoundActive(true));

    return () => {
      dispatch(setIsPageNotFoundActive(false));
    };
  }, [dispatch]);

  return (
    <PageNotFoundWrapperStyled
      data-testid="page-not-found"
      $isFullScreen={isFullScreen}
    >
      <PageNotFound404Styled variant="h1">404</PageNotFound404Styled>
      <Typography variant="h5">{t('title')}</Typography>
      <Spacer height={7} />
      <PageNotFoundDescriptionStyled variant="body2">
        {t('description')}
      </PageNotFoundDescriptionStyled>
    </PageNotFoundWrapperStyled>
  );
};
